<script setup>

import {
    onMounted,
    onBeforeUnmount
} from 'vue'

onMounted(() => {
    document.body.classList.add('layout-cuestionario')
})

onBeforeUnmount(() => {
    document.body.classList.remove('layout-cuestionario')
})

</script>

<template>
    <div id="main-wrapper">
        <div class="content-body highlight">
            <slot name="main"></slot>
        </div>
    </div>
</template>

<style scoped>
#main-wrapper {
    display: block !important;
    width: 100%;
    height: auto !important;
    min-height: 100vh;
    overflow: visible !important;
}

.content-body {
    position: relative;
    width: 100%;
    height: auto !important;
    min-height: calc(100vh - 40px);
    overflow: visible !important;
    transition: all 0.35s ease-in-out;
    margin-top: 40px !important;
    margin-left: 0 !important;
    padding: 20px 15px;
}

.heightPrincipalCardHc {
    height: auto !important;
    min-height: calc(100vh - 75px) !important;
}

.media-object {
    height: 50px;
}

.fixed {
    width: 55px;
}
</style>

<style>
body.layout-cuestionario {
    height: auto !important;
    min-height: 100% !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

body.layout-cuestionario #app {
    height: auto !important;
    min-height: 100% !important;
    overflow: visible !important;
}
</style>